import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import permissions from "@/api/permissions";

import TableContainer from "../Components/TableContainer";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

const Types = {
  AUTH: "AUTH",
  TPS: "TPS",
};

function Endpoints(props) {
  const authTable = useRef(null);
  const tpsTable = useRef(null);
  const [activeTab, setActiveTab] = useState(Types.AUTH);

  const loadPaginationAuth = async (page = 0, size = 10, search, sort) => {
    let {
      data: { content, totalElements },
    } = await permissions.getAuthEndpoints(page, size, search, sort);

    return {
      data: content,
      total: totalElements,
    };
  };

  const loadPaginationTps = async (page = 0, size = 10, search, sort) => {
    let {
      data: { content, totalElements },
    } = await permissions.getTpsEndpoints(page, size, search, sort);

    return {
      data: content,
      total: totalElements,
    };
  };

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <>
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Endpoints</CardHeader>
              <CardBody>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={{ active: activeTab === Types.AUTH }}
                      onClick={() => {
                        toggleTab(Types.AUTH);
                      }}>
                      Auth
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={{ active: activeTab === Types.TPS }}
                      onClick={() => {
                        toggleTab(Types.TPS);
                      }}>
                      TPS
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={Types.AUTH}>
                    {activeTab === Types.AUTH && (
                      <TableContainer
                        key="auth"
                        loadData={loadPaginationAuth}
                        wrappedComponentRef={innerComponent => {
                          if (innerComponent) {
                            authTable.current = innerComponent;
                          }
                        }}>
                        <BootstrapTable
                          key="auth"
                          headerStyle={headerStyle}
                          version="4"
                          search
                          pagination
                          striped
                          hover
                          condensed
                          remote>
                          <TableHeaderColumn
                            dataSort
                            isKey
                            width="200"
                            dataField="endpoint">
                            Name
                          </TableHeaderColumn>
                        </BootstrapTable>
                      </TableContainer>
                    )}
                  </TabPane>

                  <TabPane tabId={Types.TPS}>
                    {activeTab === Types.TPS && (
                      <TableContainer
                        key="tps"
                        loadData={loadPaginationTps}
                        wrappedComponentRef={innerComponent => {
                          if (innerComponent) {
                            tpsTable.current = innerComponent;
                          }
                        }}>
                        <BootstrapTable
                          key="tps"
                          headerStyle={headerStyle}
                          version="4"
                          search
                          pagination
                          striped
                          hover
                          condensed
                          remote>
                          <TableHeaderColumn
                            isKey
                            dataSort
                            width="200"
                            dataField="endpoint">
                            Name
                          </TableHeaderColumn>
                        </BootstrapTable>
                      </TableContainer>
                    )}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Endpoints;
